export type CountryType = {
  id: string;
  name: string;
  prefix: string;
  orderIndex: number;
  isEU: boolean;
  isMemberState?: boolean;
};

export const COUNTRIES: CountryType[] = [
  {
    id: 'AD',
    name: 'Andorra',
    prefix: '376',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'AE',
    name: 'United Arab Emirates',
    prefix: '971',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'AF',
    name: 'Afghanistan',
    prefix: '93',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'AG',
    name: 'Antigua and Barbuda',
    prefix: '1268',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'AL',
    name: 'Albania',
    prefix: '355',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'AM',
    name: 'Armenia',
    prefix: '374',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'AO',
    name: 'Angola',
    prefix: '244',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'AR',
    name: 'Argentina',
    prefix: '54',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'AS',
    name: 'American Samoa',
    prefix: '1684',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'AT',
    name: 'Austria',
    prefix: '43',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'AU',
    name: 'Australia',
    prefix: '61',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'AW',
    name: 'Aruba',
    prefix: '297',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'AZ',
    name: 'Azerbaijan',
    prefix: '994',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BA',
    name: 'Bosnia-Herzegovina',
    prefix: '387',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BB',
    name: 'Barbados',
    prefix: '1246',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BD',
    name: 'Bangladesh',
    prefix: '880',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BE',
    name: 'Belgium',
    prefix: '32',
    orderIndex: 2,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'BF',
    name: 'Burkina Faso',
    prefix: '226',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BG',
    name: 'Bulgaria',
    prefix: '359',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'BH',
    name: 'Bahrain',
    prefix: '973',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BI',
    name: 'Burundi',
    prefix: '257',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BJ',
    name: 'Benin',
    prefix: '229',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BM',
    name: 'Bermuda',
    prefix: '1441',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BN',
    name: 'Brunei',
    prefix: '673',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BO',
    name: 'Bolivia',
    prefix: '591',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BR',
    name: 'Brazil',
    prefix: '55',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BS',
    name: 'Bahamas',
    prefix: '1242',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BT',
    name: 'Bhutan',
    prefix: '975',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BW',
    name: 'Botswana',
    prefix: '267',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BY',
    name: 'Belarus',
    prefix: '375',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'BZ',
    name: 'Belize',
    prefix: '501',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'CA',
    name: 'Canada',
    prefix: '1',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'CD',
    name: 'Congo, Democratic Republic of the',
    prefix: '243',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'CF',
    name: 'Central African Republic',
    prefix: '236',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'CG',
    name: 'Congo',
    prefix: '242',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'CH',
    name: 'Switzerland',
    prefix: '41',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'CI',
    name: 'Ivory Coast',
    prefix: '225',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'CK',
    name: 'Cook Islands',
    prefix: '682',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'CL',
    name: 'Chile',
    prefix: '56',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'CM',
    name: 'Cameroon',
    prefix: '237',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'CN',
    name: 'China',
    prefix: '86',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'CO',
    name: 'Colombia',
    prefix: '57',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'CR',
    name: 'Costa Rica',
    prefix: '506',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'CU',
    name: 'Cuba',
    prefix: '53',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'CV',
    name: 'Cape Verde',
    prefix: '238',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'CY',
    name: 'Cyprus',
    prefix: '357',
    orderIndex: 1000,
    isMemberState: true,
    isEU: true,
  },
  {
    id: 'CZ',
    name: 'Czech Republic',
    prefix: '420',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'DE',
    name: 'Germany',
    prefix: '49',
    orderIndex: 4,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'DJ',
    name: 'Djibouti',
    prefix: '253',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'DK',
    name: 'Denmark',
    prefix: '45',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'DM',
    name: 'Dominica',
    prefix: '1767',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'DO',
    name: 'Dominican Republic',
    prefix: '18',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'DZ',
    name: 'Algeria',
    prefix: '213',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'EC',
    name: 'Ecuador',
    prefix: '593',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'EE',
    name: 'Estonia',
    prefix: '372',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'EG',
    name: 'Egypt',
    prefix: '20',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'ER',
    name: 'Eritrea',
    prefix: '291',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'ES',
    name: 'Spain',
    prefix: '34',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'ET',
    name: 'Ethiopia',
    prefix: '251',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'FI',
    name: 'Finland',
    prefix: '358',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'FJ',
    name: 'Fiji',
    prefix: '679',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'FM',
    name: 'Micronesia',
    prefix: '691',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'FR',
    name: 'France',
    prefix: '33',
    orderIndex: 3,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'GA',
    name: 'Gabon',
    prefix: '241',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'GB',
    name: 'United Kingdom',
    prefix: '44',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'GD',
    name: 'Grenada',
    prefix: '1473',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'GE',
    name: 'Georgia',
    prefix: '995',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'GG',
    name: 'Guernsey',
    prefix: '441481',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'GH',
    name: 'Ghana',
    prefix: '233',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'GI',
    name: 'Gibraltar',
    prefix: '350',
    orderIndex: 1000,
    isEU: false,
    isMemberState: true,
  },
  {
    id: 'GM',
    name: 'Gambia',
    prefix: '220',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'GN',
    name: 'Guinea',
    prefix: '224',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'GQ',
    name: 'Equatorial Guinea',
    prefix: '240',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'GR',
    name: 'Greece',
    prefix: '30',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'GT',
    name: 'Guatemala',
    prefix: '502',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'GU',
    name: 'Guam',
    prefix: '1671',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'GW',
    name: 'Guinea-Bissau',
    prefix: '245',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'GY',
    name: 'Guyana',
    prefix: '592',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'HK',
    name: 'Hong Kong',
    prefix: '852',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'HN',
    name: 'Honduras',
    prefix: '504',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'HR',
    name: 'Croatia',
    prefix: '385',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'HT',
    name: 'Haiti',
    prefix: '509',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'HU',
    name: 'Hungary',
    prefix: '36',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'ID',
    name: 'Indonesia',
    prefix: '62',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'IE',
    name: 'Ireland',
    prefix: '353',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'IL',
    name: 'Israel',
    prefix: '972',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'IM',
    name: 'Isle of Man',
    prefix: '441624',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'IN',
    name: 'India',
    prefix: '91',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'IQ',
    name: 'Iraq',
    prefix: '964',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'IR',
    name: 'Iran',
    prefix: '98',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'IS',
    name: 'Iceland',
    prefix: '354',
    orderIndex: 1000,
    isEU: false,
    isMemberState: true,
  },
  {
    id: 'IT',
    name: 'Italy',
    prefix: '39',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'JE',
    name: 'Jersey',
    prefix: '441534',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'JM',
    name: 'Jamaica',
    prefix: '1876',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'JO',
    name: 'Jordan',
    prefix: '962',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'JP',
    name: 'Japan',
    prefix: '81',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'KE',
    name: 'Kenya',
    prefix: '254',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'KG',
    name: 'Kyrgyzstan',
    prefix: '996',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'KH',
    name: 'Cambodia',
    prefix: '855',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'KI',
    name: 'Kiribati',
    prefix: '686',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'KM',
    name: 'Comoros',
    prefix: '269',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'KN',
    name: 'Saint Kitts and Nevis',
    prefix: '1869',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'KP',
    name: 'North Korea',
    prefix: '850',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'KR',
    name: 'South Korea',
    prefix: '82',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'KW',
    name: 'Kuwait',
    prefix: '965',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'KY',
    name: 'Cayman Islands',
    prefix: '1345',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'KZ',
    name: 'Kazakhstan',
    prefix: '7',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'LA',
    name: 'Laos',
    prefix: '856',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'LB',
    name: 'Lebanon',
    prefix: '961',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'LC',
    name: 'Saint Lucia',
    prefix: '1758',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'LI',
    name: 'Liechtenstein',
    prefix: '423',
    orderIndex: 1000,
    isEU: false,
    isMemberState: true,
  },
  {
    id: 'LK',
    name: 'Sri Lanka',
    prefix: '94',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'LR',
    name: 'Liberia',
    prefix: '231',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'LS',
    name: 'Lesotho',
    prefix: '266',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'LT',
    name: 'Lithuania',
    prefix: '370',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'LU',
    name: 'Luxembourg',
    prefix: '352',
    orderIndex: 1,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'LV',
    name: 'Latvia',
    prefix: '371',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'LY',
    name: 'Libya',
    prefix: '218',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MA',
    name: 'Morocco',
    prefix: '212',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MC',
    name: 'Monaco',
    prefix: '377',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MD',
    name: 'Moldova',
    prefix: '373',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'ME',
    name: 'Montenegro',
    prefix: '382',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MG',
    name: 'Madagascar',
    prefix: '261',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MH',
    name: 'Marshall Islands',
    prefix: '692',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MK',
    name: 'Former Yugoslav Republic of Macedonia',
    prefix: '389',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'ML',
    name: 'Mali',
    prefix: '223',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MM',
    name: 'Myanmar',
    prefix: '95',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MN',
    name: 'Mongolia',
    prefix: '976',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MO',
    name: 'Macao',
    prefix: '853',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MR',
    name: 'Mauritania',
    prefix: '222',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MT',
    name: 'Malta',
    prefix: '356',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'MU',
    name: 'Mauritius',
    prefix: '230',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MV',
    name: 'Maldives',
    prefix: '960',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MW',
    name: 'Malawi',
    prefix: '265',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MX',
    name: 'Mexico',
    prefix: '52',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MY',
    name: 'Malaysia',
    prefix: '60',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'MZ',
    name: 'Mozambique',
    prefix: '258',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'NA',
    name: 'Namibia',
    prefix: '264',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'NE',
    name: 'Niger',
    prefix: '227',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'NG',
    name: 'Nigeria',
    prefix: '234',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'NI',
    name: 'Nicaragua',
    prefix: '505',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'NL',
    name: 'Netherlands',
    prefix: '31',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'NO',
    name: 'Norway',
    prefix: '47',
    orderIndex: 1000,
    isEU: false,
    isMemberState: true,
  },
  {
    id: 'NP',
    name: 'Nepal',
    prefix: '977',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'NR',
    name: 'Nauru',
    prefix: '674',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'NZ',
    name: 'New Zealand',
    prefix: '64',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'OM',
    name: 'Oman',
    prefix: '968',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'PA',
    name: 'Panama',
    prefix: '507',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'PE',
    name: 'Peru',
    prefix: '51',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'PG',
    name: 'Papua New Guinea',
    prefix: '675',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'PH',
    name: 'Philippines',
    prefix: '63',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'PK',
    name: 'Pakistan',
    prefix: '92',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'PL',
    name: 'Poland',
    prefix: '48',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'PR',
    name: 'Puerto Rico',
    prefix: '1',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'PS',
    name: 'Palestine',
    prefix: '970',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'PT',
    name: 'Portugal',
    prefix: '351',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'PW',
    name: 'Palau',
    prefix: '680',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'PY',
    name: 'Paraguay',
    prefix: '595',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'QA',
    name: 'Qatar',
    prefix: '974',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'RO',
    name: 'Romania',
    prefix: '40',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'RS',
    name: 'Serbia',
    prefix: '381',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'RU',
    name: 'Russia',
    prefix: '7',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'RW',
    name: 'Rwanda',
    prefix: '250',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'SA',
    name: 'Saudi Arabia',
    prefix: '966',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'SB',
    name: 'Solomon Islands',
    prefix: '677',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'SC',
    name: 'Seychelles',
    prefix: '248',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'SD',
    name: 'Sudan',
    prefix: '249',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'SE',
    name: 'Sweden',
    prefix: '46',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'SG',
    name: 'Singapore',
    prefix: '65',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'SI',
    name: 'Slovenia',
    prefix: '386',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'SK',
    name: 'Slovakia',
    prefix: '421',
    orderIndex: 1000,
    isEU: true,
    isMemberState: true,
  },
  {
    id: 'SL',
    name: 'Sierra Leone',
    prefix: '232',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'SM',
    name: 'San Marino',
    prefix: '378',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'SN',
    name: 'Senegal',
    prefix: '221',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'SO',
    name: 'Somalia',
    prefix: '252',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'SR',
    name: 'Suriname',
    prefix: '597',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'SS',
    name: 'South Sudan',
    prefix: '211',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'ST',
    name: 'São Tomé and Príncipe',
    prefix: '239',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'SV',
    name: 'El Salvador',
    prefix: '503',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'SY',
    name: 'Syria',
    prefix: '963',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'SZ',
    name: 'Swaziland/Ngwane',
    prefix: '268',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'TD',
    name: 'Chad',
    prefix: '235',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'TG',
    name: 'Togo',
    prefix: '228',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'TH',
    name: 'Thailand',
    prefix: '66',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'TJ',
    name: 'Tajikistan',
    prefix: '992',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'TL',
    name: 'Timor-Leste',
    prefix: '670',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'TM',
    name: 'Turkmenistan',
    prefix: '993',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'TN',
    name: 'Tunisia',
    prefix: '216',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'TO',
    prefix: '676',
    name: 'Tonga',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'TR',
    name: 'Turkey',
    prefix: '90',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'TT',
    name: 'Trinidad and Tobago',
    prefix: '1868',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'TV',
    name: 'Tuvalu',
    prefix: '688',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'TW',
    name: 'Taiwan',
    prefix: '886',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'TZ',
    name: 'Tanzania',
    prefix: '255',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'UA',
    name: 'Ukraine',
    prefix: '380',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'UG',
    name: 'Uganda',
    prefix: '256',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'US',
    name: 'United States of America',
    prefix: '1',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'UY',
    name: 'Uruguay',
    prefix: '598',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'UZ',
    name: 'Uzbekistan',
    prefix: '998',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'VA',
    name: 'Vatican City',
    prefix: '379',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'VC',
    name: 'Saint Vincent and the Grenadines',
    prefix: '1784',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'VE',
    name: 'Venezuela',
    prefix: '58',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'VG',
    name: 'British Virgin Islands',
    prefix: '1284',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'VI',
    name: 'American Virgin Islands',
    prefix: '1340',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'VN',
    name: 'Vietnam',
    prefix: '84',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'VU',
    name: 'Vanuatu',
    prefix: '678',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'WS',
    name: 'Samoa',
    prefix: '685',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'YE',
    name: 'Yemen',
    prefix: '967',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'ZA',
    name: 'South Africa',
    prefix: '27',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'ZM',
    name: 'Zambia',
    prefix: '260',
    orderIndex: 1000,
    isEU: false,
  },
  {
    id: 'ZW',
    name: 'Zimbabwe',
    prefix: '263',
    orderIndex: 1000,
    isEU: false,
  },
];

export const COUNTRIES_EU = COUNTRIES.filter((country) => country.isEU);
export const COUNTRIES_MEMBER_STATE = COUNTRIES.filter((country) => country.isMemberState);
